import './Herosection.css';
import heroimg from '../assets/images/diyahomepage.png';
import grpimg from '../assets/images/home/group_profiles.png';

import { FaArrowRightLong } from "react-icons/fa6";
import React from 'react';
import { Link } from 'react-router-dom'; // ✅ Import Link

function Herosection() {
    return (
        <React.Fragment>
            <section className="container" id='Home'>
                <div className="container" id='home-container'>
                    <div className='row'>
                        <div className='col-12 col-md-6 hero-title-div'>
                            <p className='hero-title'>
                                Welcome to FutureHealth.ai for Smarter Patient Monitoring
                            </p>
                            <div className='group-img'>
                                <img src={grpimg} alt='group img' />
                                <p>Access real-time patient vitals, and collaborate with patients effortlessly using our advanced connected care system.</p>
                            </div>
                            
                            <Link to="/caretaker-login" className='rounded-pill'>
                                Care Taker Login <span><FaArrowRightLong /></span>
                            </Link>
                        </div>

                        <div className='col-12 col-md-6 hero-img'>
                            <img src={heroimg} alt='heroimage' className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default Herosection;
